import { render, staticRenderFns } from "./OverviewBox.vue?vue&type=template&id=a35ec58a&scoped=true"
import script from "./OverviewBox.vue?vue&type=script&lang=js"
export * from "./OverviewBox.vue?vue&type=script&lang=js"
import style0 from "./OverviewBox.vue?vue&type=style&index=0&id=a35ec58a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35ec58a",
  null
  
)

export default component.exports